export default () => ({
  doctorId: "",
  messageType: "",
  messageTime: "",
  messageTimeState: "",
  messageMobiles: [],
  message: "",
  messageUnit: "",
  messageValue: "",
});
